import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';

/**
 * Data Table Component using react-data-table-component
 * Displays data in a sortable, filterable table
 */
const DataTableComponent = () => {
  const [filterText, setFilterText] = useState('');

  // Sample data
  const data = [
    {
      id: 1,
      name: 'John Doe',
      email: 'john@example.com',
      role: 'Admin',
      createdAt: moment().subtract(5, 'days').toISOString(),
    },
    {
      id: 2,
      name: 'Jane Smith',
      email: 'jane@example.com',
      role: 'User',
      createdAt: moment().subtract(3, 'days').toISOString(),
    },
    {
      id: 3,
      name: 'Bob Johnson',
      email: 'bob@example.com',
      role: 'Manager',
      createdAt: moment().subtract(1, 'day').toISOString(),
    },
  ];

  // Table columns
  const columns = [
    {
      name: 'ID',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Role',
      selector: (row) => row.role,
      sortable: true,
    },
    {
      name: 'Created',
      selector: (row) => moment(row.createdAt).format('MMM DD, YYYY'),
      sortable: true,
    },
  ];

  // Filter data based on search text
  const filteredData = data.filter(
    (item) =>
      item.name.toLowerCase().includes(filterText.toLowerCase()) ||
      item.email.toLowerCase().includes(filterText.toLowerCase()) ||
      item.role.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <div className="data-table-component">
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search by name, email, or role..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        highlightOnHover
        striped
        responsive
        noDataComponent="No records found"
      />
    </div>
  );
};

export default DataTableComponent;
